import { useState } from 'react';
import { toast } from 'sonner';
import { Area, AzDrawer, Bubble, Btn, Lbl } from '../../components/az';
import { useActionStep, useFlagCall } from '../../queries/actions';
import { firstName } from '../../utils/actions';
import * as S from './styled';

const WHAT = ['Wrong fact', 'Wrong urgency', 'Sent to the wrong person', "Said something it shouldn't", 'Other'];

export default function FlagDrawer({ subject, callId, agent, orgName, onClose }) {
  const [what, setWhat] = useState('Wrong fact');
  const [right, setRight] = useState('');
  const canFix = Boolean(subject.contact?.phone);
  const [fix, setFix] = useState(canFix);
  const step = useActionStep();
  const flagCall = useFlagCall();
  const draft = `${orgName}: Hi ${firstName(subject.contact?.name || subject.who)}, this is ${agent}. A correction: ${right || "[what's right]"}. Sorry for the mix-up. Reply STOP to opt out.`;

  const send = () => {
    const payload = { what, right, fix: fix && canFix };
    const done = {
      onSuccess: () => {
        toast('Flagged. A knowledge fix is in Agent Actions.');
        onClose();
      }
    };
    if (callId) flagCall.mutate({ id: callId, ...payload }, done);
    else step.mutate({ id: subject._id, step: 'flag', payload }, done);
  };

  return (
    <AzDrawer title="Not right" eyebrow="Was this right?" onClose={onClose}>
      <S.Col $gap={12}>
        <S.Sm>
          <b>{subject.title}</b>
          {subject.who ? ` · ${subject.who}` : ''}
        </S.Sm>
        <S.Col $gap={4} role="radiogroup" aria-label="What was wrong?">
          <Lbl as="div">What was wrong?</Lbl>
          {WHAT.map((o) => (
            <S.Radio key={o}>
              <input type="radio" name="wtr" checked={what === o} onChange={() => setWhat(o)} />
              {o}
            </S.Radio>
          ))}
        </S.Col>
        <S.Col $gap={4}>
          <Lbl htmlFor="wtr-right">What's right?</Lbl>
          <Area id="wtr-right" rows={3} maxLength={300} value={right} onChange={(e) => setRight(e.target.value)} />
          <S.Xs $muted style={{ fontVariantNumeric: 'tabular-nums' }}>
            {right.length} / 300
          </S.Xs>
        </S.Col>
        {canFix ? (
          <S.Radio>
            <input type="checkbox" checked={fix} onChange={() => setFix(!fix)} />
            Fix it for the caller
          </S.Radio>
        ) : (
          <S.Xs $muted>No phone number, so no correction text.</S.Xs>
        )}
        {fix && canFix && <Bubble>{draft}</Bubble>}
        <S.Row>
          <Btn onClick={onClose}>Cancel</Btn>
          <div style={{ flex: 1 }} />
          <Btn kind="primary" onClick={send} disabled={step.isPending || flagCall.isPending}>
            Send
          </Btn>
        </S.Row>
      </S.Col>
    </AzDrawer>
  );
}
